/**
 * Return the URL to the widget SDK
 * @param awsAccountId The AWS account ID
 */
export function getWidgetUrl(awsAccountId?: string): string {
  switch (awsAccountId) {
    case "644084073510": // production
      return "https://widget.fbot.me/";
    case "913709512847": // staging
      return "https://widget.fbot-staging.me/";
    case "755386480951": // qa
      return "https://widget.fbot-qa.me/";
    case "627208980326": // sandbox
      return "https://widget.fbot-sandbox.me/";
    case "266256754960": // applause
      return "https://widget.fbot-applause.me/";
    default:
      return `http://fbt-widget-sdk-${awsAccountId}.s3-website-us-east-1.amazonaws.com/`;
  }
}
